'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectors = undefined;

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _reselect = require('reselect');

var _componentHelpers = require('../../utils/component-helpers');

var _common = require('./common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getSelectors = exports.getSelectors = function getSelectors(identifier, isOnPage) {
  var getAccordionData = (0, _reselect.createSelector)([_common.getCardData, _common.getPageData], function (card, page) {
    return (0, _lodash2.default)(isOnPage ? page : card, identifier) || {};
  });
  var getHeaderTitle = (0, _reselect.createSelector)(getAccordionData, function (_ref) {
    var header = _ref.header;
    return header;
  });
  var getHeaderImage = (0, _reselect.createSelector)(getAccordionData, function (_ref2) {
    var assets = _ref2.assets;

    var asset = (assets || []).find(function (a) {
      return a.type === 'TILE';
    }) || {};

    return asset && {
      src: asset.url,
      alt: asset.alt
    };
  });
  var getTextbox = (0, _reselect.createSelector)(getAccordionData, function (_ref3) {
    var desc = _ref3.desc;
    return (0, _componentHelpers.concactDescStr)(desc);
  });
  var getMiddleSectionHeaders = (0, _common.getMiddleSectionHeadersSelector)(getAccordionData);
  var getMiddleSectionContent = (0, _common.getMiddleSectionContentSelector)(getAccordionData);

  var getQeId = (0, _reselect.createSelector)(getAccordionData, function (accordionData) {
    return accordionData.qeId;
  });

  return {
    getAccordionData: getAccordionData,
    getHeaderTitle: getHeaderTitle,
    getHeaderImage: getHeaderImage,
    getTextbox: getTextbox,
    getMiddleSectionHeaders: getMiddleSectionHeaders,
    getMiddleSectionContent: getMiddleSectionContent,
    getQeId: getQeId
  };
};